/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Загрузка...',
	'dlg_close': 'Закрыть',
	'dlg_ok': 'ОК',
	'dlg_cancel': 'Отмена',
	'dlg_back': 'Перейти назад',

	// Slider
	'sliderRegionLabel': 'Элемент управления ползунком; чтобы переместить хэндлы ползунка, используйте стрелки вправо и влево',
	'sliderHandleLabel': 'Хэндл ползунка',
	'a11ySliderHandleLabel': 'Хэндл ползунка %{sliderValue}',
	'sliderInputLabel': 'значение',

	// Side bar
	'sidebarAdd': 'Добавить',
	'clearTextFilterValue': 'Очистить',
	'missingDataSetData': 'Данные для этого набора данных недоступны. Обновите набор данных или обратитесь к своему администратору, чтобы получить доступ к источнику.',

	// Toolbar
	'toolbarRegionLabel': 'Панель инструментов',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Семейство шрифтов',
	'fontSizeSelect': 'Размер шрифта',
	'bold': 'Полужирный',
	'italic': 'Курсив',
	'underline': 'Подчеркивание',
	'justifyLeft': 'Выровнять по левому краю',
	'justifyCenter': 'Выровнять по центру',
	'justifyRight': 'Выровнять по правому краю',
	'insertOrderedList': 'Упорядоченный список',
	'insertUnorderedList': 'Неупорядоченный список',
	'fontColorPicker': 'Выбор цвета',
	'textWrap': 'Перенос текста',
	'restore': 'Восстановить значения по умолчанию',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Число результатов',
	'topbottomPercentLabel': 'Процент',
	'topbottomNumberOfResultsLimit': 'Значение может быть в диапазоне %{lower} - %{higher}',
	'topbottomSelectOption': 'Опция Первые или последние',
	'topbottomOptionLabel': 'Показать',
	'searchByLabel': 'На основе',
	'searchNoMatches': 'Совпадения не найдены',
	'topbottomRankColumnLabel': 'Добавить в таблицу столбец ранга',
	'topbottomNone': 'Нет',
	'topCount': 'Число первых',
	'topPercent': 'Первые %',
	'bottomCount': 'Число последних',
	'bottomPercent': 'Последние %',
	'searchColumn': 'Найти столбец',
	'searchColumnAriaLabel': 'Найдите столбец. Введите имя столбца, который нужно искать, а затем используйте стрелку вниз, чтобы найти столбец в списке',
	'rankColumnLabel': 'Ранг (%{columnLabel})',
	'topbottomClearLabel': 'Очистить',

	// Format
	'formatAuto': 'Автоматически',
	'formatConvertPercent': 'Преобразовать десятичное число в процент',
	'formatAbbreviate': 'Сокращать',
	'formatUseGrouping': 'Использовать разделитель тысяч',
	'dateStyle': 'Стиль дат',
	'dateTimeStyle': 'Стиль даты и времени',
	'formatMissingValueCharactersInfo': 'Символы пропущенных значений позволяют указать символы, которые должны появляться на экране вместо пропущенного значения.',
	'currencySymbolLabel': 'Обозначение валюты',
	'customSymbolPlaceholder': 'Добавить символ',
	'customSymbolLabelInfo': 'Указывает символ или символы для использования в качестве пользовательского символа. Этот символ будет предшествовать числу и любому знаку.',
	'numberLabel': 'Числовая метка',
	'numberPositionLabel': 'Положение метки',
	'numberLabelInfo': 'Определяет метку для отформатированного числа и помещается в виде префикса или суффикса в зависимости от положения метки.',
	'nullValueDefault': '<по умолчанию>',
	'nullValueContent': '(нет значения)',
	'default': 'По умолчанию',
	'beginning': 'Начало',
	'end': 'Конец',

	// More data indicator
	'moreDataIndicator': 'Ваши данные обрезаны на уровне %{threshold} элементов. Примените фильтр, чтобы показать меньше данных.',

	// Expanded View / Focus mode
	'evCollapse': 'Свернуть',
	'duplicate': 'Дублировать',
	'copyOf': 'Копия %{name}',
	'unableToDuplicateBoard': 'Не удается дублировать "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Мы не можем загрузить объекты.',

	// Custom widgets
	'customWidget': 'Пользовательский виджет'
});
